import React, { useState } from "react";
import { auth, db } from "../../../api/firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { getSpecificMessage, saveNewMessage } from "../../../api/restApi";
import { getMessage } from "../../../api/endPoints";
import { useSelector } from "react-redux";
const styles = {
  form: {
    height: "56px",
    width: "100%",
    maxWidth: "728px",
    display: "flex",
    fontSize: "16px",
    position: "sticky",
    bottom: "0",
  },
  input: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#282c34",
    color: "white",
    outline: "none",
    border: "none",
    fontSize: "16px",
  },
  button: {
    width: "20%",
    backgroundColor: "#4caf50",
    color: "white",
    border: "none",
  },
};

const SendMessage = (rowData) => {
  const [input, setInput] = useState("");
  const user = useSelector((state) => state.currentUser);
  console.log(user);
  const role = user.role;
  const name = user.name;
  console.log(rowData.rowData.rowData);
  const selectedRowData = rowData.rowData?.rowData;
  console.log(selectedRowData.name);

  const timestamp = new Date();

  const formattedTime = timestamp.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  const orderTime = timestamp.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 3,
  });

  const sendMessage = async (e) => {
    e.preventDefault();
    if (input === "") {
      alert("Please enter a valid message");
      return;
    }
    const { uid } = auth.currentUser;
    console.log(uid);
    await saveNewMessage(selectedRowData.id, {
      text: input,
      name: name,
      uid: uid,
      timestamp: serverTimestamp(),
      orderTime:orderTime,
      time: formattedTime,
    });

    const messages = await getSpecificMessage(selectedRowData.id);

    console.log("messages: ", messages);
    // await addDoc(collection(db, 'messages'), {
    // text: input,
    // name: displayName,
    // uid,
    // timestamp: serverTimestamp(),
    // });
    setInput("");
    // scroll.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <form onSubmit={sendMessage} style={styles.form}>
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={styles.input}
        type="text"
        placeholder="Message"
      />
      <button style={styles.button} type="submit">
        Send
      </button>
    </form>
  );
};

export default SendMessage;
